/* Nutraviva homepage behaviour: reveal, hero intro, parallax, tabs, filters, buy toggle, sticky bar. */
(function () {
  if (window.NVHome) return; window.NVHome = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('nv-js');
  var io = ('IntersectionObserver' in window) && !reduce ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; var el = e.target; el.classList.remove('nv-pre'); el.classList.add('nv-in'); io.unobserve(el); });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .05 }) : null;

  function init(root) {
    /* Pagination dots for any scroller marked data-nv-dots. Built here rather
       than in Liquid so one attribute is enough to opt a rail in, and so the
       dots disappear on a viewport where every tile already fits. */
    root.querySelectorAll('[data-nv-dots]').forEach(function (rail) {
      if (rail.dataset.nvDotsOn) return;
      rail.dataset.nvDotsOn = '1';
      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) return;
      var nav = document.createElement('div');
      nav.className = 'nv-dots';
      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nv-dot';
        b.setAttribute('aria-label', 'Show ' + (i + 1) + ' of ' + items.length);
        b.addEventListener('click', function () {
          rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        });
        nav.appendChild(b);
      });
      rail.parentNode.insertBefore(nav, rail.nextSibling);
      function sync() {
        var best = 0, bd = Infinity;
        items.forEach(function (item, i) {
          var d = Math.abs(item.offsetLeft - rail.offsetLeft - rail.scrollLeft);
          if (d < bd) { bd = d; best = i; }
        });
        for (var i = 0; i < nav.children.length; i++) {
          nav.children[i].classList.toggle('is-on', i === best);
        }
      }
      function toggle() {
        var scrolls = rail.scrollWidth - rail.clientWidth > 4;
        nav.hidden = !scrolls;
        if (scrolls) sync();
      }
      rail.addEventListener('scroll', sync, { passive: true });
      addEventListener('resize', toggle);
      toggle();
    });

    root = root || document;
    if (io) root.querySelectorAll('[data-nv-reveal]:not(.nv-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight * .9) return;
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--d', Math.min(sib, 5) * 70 + 'ms'); el.classList.add('nv-pre'); io.observe(el);
    });
    root.querySelectorAll('[data-nv-hero]').forEach(function (h) {
      if (reduce || h.dataset.nvDone) return; h.dataset.nvDone = 1;
      var m = h.querySelector('[data-nv-hero-media]'); if (m && m.animate) m.animate([{ transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 1600, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
      h.querySelectorAll('[data-nv-in]').forEach(function (el, i) { if (el.animate) el.animate([{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }], { duration: 700, delay: 150 + i * 110, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }); });
      var b = h.querySelector('[data-nv-pause]'), v = h.querySelector('video');
      if (b && v) b.addEventListener('click', function () { if (v.paused) { v.play(); b.textContent = 'II'; b.setAttribute('aria-label', 'Pause video'); } else { v.pause(); b.textContent = 'Play'; b.setAttribute('aria-label', 'Play video'); } });
    });
    root.querySelectorAll('[data-nv-tabs]').forEach(function (t) {
      if (t.dataset.nvDone) return; t.dataset.nvDone = 1;
      var tabs = t.querySelectorAll('[data-nv-tab]'), panels = t.querySelectorAll('[data-nv-panel]'), ms = +t.dataset.interval || 0, cur = 0, timer;
      function go(i, auto) {
        cur = i;
        tabs.forEach(function (b, n) { b.classList.toggle('is-on', n === i); b.setAttribute('aria-selected', n === i); b.setAttribute('aria-checked', n === i); b.classList.remove('is-timing'); });
        panels.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
        if (auto && ms && !reduce) { var b = tabs[i]; b.style.setProperty('--t', ms + 'ms'); void b.offsetWidth; b.classList.add('is-timing'); }
      }
      tabs.forEach(function (b, n) { b.addEventListener('click', function () { clearInterval(timer); go(n, false); }); });
      go(0, true);
      if (ms && !reduce) timer = setInterval(function () { go((cur + 1) % tabs.length, true); }, ms);
    });
    root.querySelectorAll('[data-nv-filter-root]').forEach(function (r) {
      if (r.dataset.nvDone) return; r.dataset.nvDone = 1;
      r.querySelectorAll('[data-nv-filter]').forEach(function (c) {
        c.addEventListener('click', function () {
          var f = c.dataset.nvFilter;
          r.querySelectorAll('[data-nv-filter]').forEach(function (x) { x.classList.toggle('is-on', x === c); });
          r.querySelectorAll('[data-tags]').forEach(function (it) { it.hidden = f !== 'all' && it.dataset.tags.split(',').map(function (s) { return s.trim(); }).indexOf(f) < 0; });
        });
      });
    });
    /* Featured product size picker. Selecting a size sets the variant the form
       will submit AND rewrites both price rows, so what is on screen is what the
       cart charges. Prices come from data attributes rendered by Liquid, so they
       are Shopify's own money formatting rather than anything assembled here. */
    root.querySelectorAll('[data-nv-feat-sizes]').forEach(function (group) {
      var form = group.closest('form');
      if (!form) return;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-nv-variant]');
        if (!btn || btn.disabled) return;
        group.querySelectorAll('[data-nv-variant]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var id = form.querySelector('[data-nv-feat-id]');
        if (id) id.value = btn.getAttribute('data-nv-variant');
        var once = form.querySelector('[data-nv-feat-once]');
        var sub = form.querySelector('[data-nv-feat-sub]');
        var was = form.querySelector('[data-nv-feat-was]');
        if (once) once.textContent = btn.getAttribute('data-nv-price');
        if (was) was.textContent = btn.getAttribute('data-nv-price');
        if (sub) sub.textContent = btn.getAttribute('data-nv-sub');
      });
    });

    root.querySelectorAll('[data-nv-buy]').forEach(function (f) {
      f.addEventListener('change', function () { f.querySelectorAll('.nv-buy').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); }); });
    });
    /* Endless carousel. Advances one card, then recycles the card that just left
       to the end of the strip and rolls scrollLeft back by the same amount - so
       it loops forever with no rewind, and without cloning the <video> elements.
       Holds while hovered, focused, touched, off-screen, the tab is hidden, or a
       video is actually playing, so a clip is never scrolled away mid-watch. */
    root.querySelectorAll('[data-nv-autoscroll]').forEach(function (el) {
      if (el.dataset.nvAutoOn) return; el.dataset.nvAutoOn = '1';
      var secs = parseFloat(el.dataset.nvAutoscroll);
      if (!secs || secs <= 0 || reduce) return;
      var held = false, seen = true, busy = false;
      function hold(on) { return function () { held = on; }; }
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) {
        el.addEventListener(ev, hold(true), { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        el.addEventListener(ev, hold(false), { passive: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0 }).observe(el);
      }
      function playing() {
        return !!el.querySelector('video:not([data-nv-idle])');
      }
      function step() {
        var card = el.firstElementChild; if (!card) return 0;
        var cs = getComputedStyle(el);
        return card.getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 0);
      }
      function advance() {
        if (held || busy || !seen || document.hidden || playing()) return;
        if (el.scrollWidth - el.clientWidth < 4) return;
        var card = el.firstElementChild; if (!card) return;
        var d = step(); if (!d) return;
        busy = true;
        el.scrollBy({ left: d, behavior: 'smooth' });
        setTimeout(function () {
          /* recycle only once the card has genuinely left the viewport, else a
             cancelled smooth-scroll would shuffle cards under the shopper. */
          if (el.scrollLeft >= d - 2) { el.appendChild(card); el.scrollLeft -= d; }
          busy = false;
        }, 650);
      }
      setInterval(advance, secs * 1000);
    });

    /* UGC playback. Muted hover-preview because browsers will not autoplay with
       sound; a tap on the tile plays it WITH sound, and the speaker button
       toggles. Only one clip is ever audible. */
    root.querySelectorAll('[data-nv-ugc]').forEach(function (v) {
      var w = v.closest('.nv-ugc'); if (!w || w.dataset.nvUgcOn) return; w.dataset.nvUgcOn = '1';
      var btn = w.querySelector('[data-nv-sound]');
      v.setAttribute('data-nv-idle', '');           // marks "not playing" for the carousel hold
      function mark() {
        if (v.paused) v.setAttribute('data-nv-idle', ''); else v.removeAttribute('data-nv-idle');
        if (btn) { btn.setAttribute('aria-pressed', String(!v.muted)); btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off'); }
      }
      v.addEventListener('play', mark); v.addEventListener('pause', mark);
      v.addEventListener('volumechange', mark);

      function silenceOthers() {
        document.querySelectorAll('[data-nv-ugc]').forEach(function (o) { if (o !== v) { o.muted = true; o.pause(); } });
      }
      w.addEventListener('mouseenter', function () { if (v.muted) v.play().catch(function () {}); });
      w.addEventListener('mouseleave', function () { if (v.muted) v.pause(); });
      w.addEventListener('click', function (e) {
        if (e.target.closest('form') || e.target.closest('[data-nv-sound]')) return;
        if (v.paused) { silenceOthers(); v.muted = false; v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); }
        else if (v.muted) { silenceOthers(); v.muted = false; }      // hovering muted -> give it sound
        else { v.pause(); }
        mark();
      });
      if (btn) btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!v.muted) { v.muted = true; }
        else { silenceOthers(); v.muted = false; if (v.paused) v.play().catch(function () {}); }
        mark();
      });
      mark();
    });

    /* Add to cart without leaving the page. Posts to /cart/add.js and hands the
       response to the theme's cart drawer. Any failure - no drawer, no routes,
       a rejected add - falls back to a real form post so a shopper is never
       stuck on a button that silently does nothing. */
    function nvDrawer() { var d = document.querySelector('cart-drawer'); return (d && d.renderContents && window.routes && window.routes.cart_add_url) ? d : null; }

    function nvAdd(body, btn, onFail) {
      var drawer = nvDrawer();
      if (!drawer) { onFail(); return; }
      if (btn) { if (btn.dataset.nvBusy) return; btn.dataset.nvBusy = '1'; btn.setAttribute('aria-busy', 'true'); }
      var label = btn ? btn.innerHTML : '';
      if (btn) btn.textContent = 'Adding\u2026';
      body.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
      body.append('sections_url', window.location.pathname);
      if (btn && drawer.setActiveElement) drawer.setActiveElement(btn);
      function restore() { if (btn) { btn.innerHTML = label; delete btn.dataset.nvBusy; btn.removeAttribute('aria-busy'); } }
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error(d.description || d.message || 'Could not add');
          // An empty cart loads the drawer flagged is-empty, which hides its header and items.
          // The theme's own product form clears the flag after adding; do the same here.
          drawer.classList.remove('is-empty');
          drawer.renderContents(d);
          restore();
          document.querySelectorAll('[data-nv-quick]').forEach(function (q) { q.hidden = true; });
          document.querySelectorAll('[data-nv-choose]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        })
        .catch(function () { restore(); onFail(); });
    }

    root.querySelectorAll('form[data-nv-atc]').forEach(function (f) {
      if (f.dataset.nvAtcOn) return; f.dataset.nvAtcOn = '1';
      f.addEventListener('submit', function (e) {
        if (!nvDrawer()) return;                       // let it post natively
        e.preventDefault();
        nvAdd(new FormData(f), f.querySelector('[type="submit"]'), function () {
          f.removeAttribute('data-nv-atc'); f.submit();
        });
      });
    });

    /* Ask for the size before adding, when a card has more than one. Mirrors the
       collection card so the two behave the same way. */
    root.querySelectorAll('[data-nv-choose]').forEach(function (b) {
      if (b.dataset.nvChooseOn) return; b.dataset.nvChooseOn = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var card = b.closest('.nv-card'); if (!card) return;
        var q = card.querySelector('[data-nv-quick]'); if (!q) return;
        var opening = q.hidden;
        document.querySelectorAll('[data-nv-quick]').forEach(function (o) { if (o !== q) o.hidden = true; });
        document.querySelectorAll('[data-nv-choose]').forEach(function (o) { if (o !== b) o.setAttribute('aria-expanded', 'false'); });
        q.hidden = !opening;
        b.setAttribute('aria-expanded', String(opening));
        if (opening) { var first = q.querySelector('.nv-quick__size'); if (first) first.focus({ preventScroll: true }); }
      });
    });

    root.querySelectorAll('[data-nv-add]').forEach(function (b) {
      if (b.dataset.nvAddOn) return; b.dataset.nvAddOn = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var id = b.getAttribute('data-nv-add'); if (!id) return;
        var fd = new FormData(); fd.append('id', id); fd.append('quantity', 1);
        nvAdd(fd, b, function () { window.location.href = '/cart'; });
      });
    });

    /* A click anywhere else closes an open size picker. */
    if (!document.documentElement.dataset.nvQuickDismiss) {
      document.documentElement.dataset.nvQuickDismiss = '1';
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-nv-quick]') || e.target.closest('[data-nv-choose]')) return;
        document.querySelectorAll('[data-nv-quick]').forEach(function (q) { q.hidden = true; });
        document.querySelectorAll('[data-nv-choose]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    }
  }

  var px = [], sticky = null, trig = null;
  function collect() {
    px = Array.prototype.slice.call(document.querySelectorAll('[data-nv-parallax]'));
    sticky = document.querySelector('[data-nv-sticky]');
    trig = sticky ? document.querySelector(sticky.dataset.trigger || '.nv-panel--deep') : null;
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (!reduce) px.forEach(function (el) { var r = el.parentElement.getBoundingClientRect(); var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - innerHeight / 2) / innerHeight)); el.style.transform = 'translate3d(0,' + (-p * 4).toFixed(2) + '%,0)'; });
      if (sticky && trig) { var on = trig.getBoundingClientRect().bottom < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); var btn = sticky.querySelector('button'); if (btn) btn.tabIndex = on ? 0 : -1; }
    });
  }
  function boot() { init(document); collect(); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); collect(); onScroll(); });
})();
